import React from 'react';

export default function ModalWrapper({ isOpen, onClose, title, icon, children }) {
  if (!isOpen) return null;

  return (
    <>
      <div className="modal-backdrop fade show" style={{ zIndex: 1050 }}></div>
      <div className="modal fade show d-block" tabIndex="-1" onClick={onClose} style={{ zIndex: 1055 }}>
        <div className="modal-dialog modal-dialog-centered modal-lg modal-fullscreen-md-down" onClick={e => e.stopPropagation()}>
          <div className="custom-modal modal-content bg-dark text-white border-secondary h-100">
            <div className="modal-header border-secondary">
              <h5 className="modal-title brand-text text-info">
                {icon && <i className={`fa ${icon} me-2`}></i>}
                {title}
              </h5>
              <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
            </div>
            {children}
          </div>
        </div>
      </div>
    </>
  );
}